import { render } from "./PartenaireSection.vue?vue&type=template&id=28e7fce0"
import script from "./PartenaireSection.vue?vue&type=script&lang=js"
export * from "./PartenaireSection.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__